import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const API_BASE = import.meta.env.VITE_API_URL || `http://${window.location.hostname}:7070`;

const styles = {
  page: {
    minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#0F172A', fontFamily: 'system-ui, sans-serif',
  },
  card: {
    background: '#1E293B', borderRadius: 12, padding: '2rem', width: '100%', maxWidth: 380,
    boxShadow: '0 4px 24px rgba(0,0,0,0.25)', border: '1px solid #334155',
  },
  title: { margin: '0 0 0.5rem', fontSize: '1.4rem', fontWeight: 700, color: '#F8FAFC' },
  subtitle: { margin: '0 0 1.5rem', fontSize: '0.9rem', color: '#94A3B8' },
  label: { display: 'block', fontSize: '0.85rem', fontWeight: 600, color: '#94A3B8', marginBottom: 4 },
  input: {
    width: '100%', padding: '0.6rem 0.75rem', borderRadius: 8, border: '1.5px solid #334155',
    fontSize: '1rem', boxSizing: 'border-box', outline: 'none', marginBottom: '1rem',
    background: '#1E293B', color: '#F8FAFC',
  },
  btn: {
    width: '100%', padding: '0.75rem', borderRadius: 8, border: 'none',
    background: 'linear-gradient(135deg, #7C3AED, #06B6D4)', color: '#fff', fontSize: '1rem', fontWeight: 600,
    cursor: 'pointer', marginTop: 4,
  },
  error: { color: '#EF4444', fontSize: '0.875rem', marginBottom: '1rem' },
  success: { color: '#22C55E', fontSize: '0.875rem', marginBottom: '1rem' },
};

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/api/v1/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.message || t('forgotPassword.error'));
        return;
      }
      setSent(true);
    } catch {
      setError(t('forgotPassword.networkError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>{t('forgotPassword.title')}</h1>
        <p style={styles.subtitle}>{t('forgotPassword.subtitle')}</p>
        {error && <p style={styles.error}>{error}</p>}
        {sent ? (
          <>
            <p style={styles.success}>{t('forgotPassword.sent')}</p>
            <Link to="/admin/login" style={{ color: '#7C3AED', fontWeight: 600, fontSize: '0.85rem' }}>
              {t('forgotPassword.backToLogin')}
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <label style={styles.label}>{t('forgotPassword.emailLabel')}</label>
            <input
              style={styles.input} type="email" placeholder={t('forgotPassword.emailPlaceholder')}
              value={email} onChange={(e) => setEmail(e.target.value)} required
            />
            <button style={styles.btn} type="submit" disabled={loading}>
              {loading ? t('forgotPassword.sending') : t('forgotPassword.submit')}
            </button>
            <p style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '0.85rem', color: '#94A3B8' }}>
              <Link to="/admin/login" style={{ color: '#7C3AED', textDecoration: 'none', fontWeight: 600 }}>
                {t('forgotPassword.backToLogin')}
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
